webpackJsonp([34],{

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1168)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1112),
  /* template */
  __webpack_require__(1180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5940f673",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


function created() {
	var _this = this;

	if (this.realTime) {
		this.intervalId = setInterval(function () {
			_this.$emit('increase-time');
		}, 1000);
	}
}

function data() {
	return {
		intervalId: null
	};
}

function formatTime(value) {
	return value < 10 ? '0' + value : value;
}

function destroyed() {
	clearInterval(this.intervalId);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	data: data,
	destroyed: destroyed,
	filters: {
		formatTime: formatTime
	},
	name: 'clock',
	props: {
		minute: {
			type: Number,
			default: 0
		},
		second: {
			type: Number,
			default: 0
		},
		realTime: {
			type: Boolean,
			default: true
		}
	}
});

/***/ }),

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


function mounted() {
	var deg = 270 + this.percent * 180 / 100;
	this.$refs.needle.style.transform = 'rotate(' + deg + 'deg)';
}

function needleDeg() {
	var deg = 270 + this.percent * 180 / 100;
	return 'transform: rotate(' + deg + 'deg)';
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'gauge',
	computed: {
		needleDeg: needleDeg
	},
	mounted: mounted,
	props: {
		heightNeedle: {
			type: [Number, String],
			default: 51.1
		},
		widthGauge: {
			type: [Number, String],
			default: 78.9
		},
		percent: {
			type: [Number, String],
			default: 0
		}
	}
});

/***/ }),

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var TASK_DELETE_EVENT = 'task-delete';
var TASK_SELECTED_EVENT = 'task-selected';
var TEXT_CHANGE_EVENT = 'input';

function onCloseTask() {
	this.$emit(TASK_DELETE_EVENT, this.value);
}

function onSelectTask() {
	this.$emit(TASK_SELECTED_EVENT, this.isSelected);
}

function onTextChange(e) {
	this.$emit(TEXT_CHANGE_EVENT, e.target.value);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'task-item',
	props: {
		isSelected: {
			type: Boolean,
			required: true
		},
		value: {
			type: String,
			required: true
		}
	},
	methods: {
		onCloseTask: onCloseTask,
		onSelectTask: onSelectTask,
		onTextChange: onTextChange
	}
});

/***/ }),

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskItem__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TaskItem__);
//
//
//
//
//
//
//
//




function onTaskSelected(index) {
	var currentTask = this.tasks[index];
	currentTask.isSelected = !currentTask.isSelected;
}

function onTaskDelete(index) {
	this.tasks.splice(index, 1);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TaskItem: __WEBPACK_IMPORTED_MODULE_0__TaskItem___default.a
	},
	name: 'tasks-list',
	props: {
		tasks: {
			type: Array,
			required: true
		}
	},
	methods: {
		onTaskSelected: onTaskSelected,
		onTaskDelete: onTaskDelete
	}
});

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".clock-container[data-v-20aa2ce3]{display:-webkit-box;display:-ms-flexbox;display:flex}.clock-container p[data-v-20aa2ce3]{margin:0}.clock-container .time-container[data-v-20aa2ce3]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-left:11px}.clock-container .time-container .label[data-v-20aa2ce3]{color:#353c4c;font-family:San Francisco Display Medium;font-size:14px;font-weight:500;line-height:1}.clock-container .time-container .time[data-v-20aa2ce3]{color:gray;font-family:Conv_sf_compact_displayultralight;font-size:40px;font-weight:200;line-height:.8}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/Clock.vue"],"names":[],"mappings":"AACA,kCACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACI,QAAU,CACb,AACD,kDACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,gBAAkB,CACrB,AACD,yDACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CACpB,AACD,wDACM,WAAe,AACf,8CAAiD,AACjD,eAAgB,AAChB,gBAAiB,AACjB,cAAiB,CACtB","file":"Clock.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.clock-container[data-v-20aa2ce3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.clock-container p[data-v-20aa2ce3] {\n    margin: 0;\n}\n.clock-container .time-container[data-v-20aa2ce3] {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    margin-left: 11px;\n}\n.clock-container .time-container .label[data-v-20aa2ce3] {\n      color: #353c4c;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 1;\n}\n.clock-container .time-container .time[data-v-20aa2ce3] {\n      color: #808080;\n      font-family: \"Conv_sf_compact_displayultralight\";\n      font-size: 40px;\n      font-weight: 200;\n      line-height: 0.8;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".gauge-container[data-v-3ef3344e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.gauge-image-container[data-v-3ef3344e]{position:relative}.gauge-image-container .gauge[data-v-3ef3344e]{vertical-align:bottom}.needle[data-v-3ef3344e]{position:absolute;left:47.8%;-webkit-transform:rotate(270deg);transform:rotate(270deg);-webkit-transform-origin:bottom center;transform-origin:bottom center;-webkit-transition:-webkit-transform .3s ease-in;transition:-webkit-transform .3s ease-in;transition:transform .3s ease-in;transition:transform .3s ease-in,-webkit-transform .3s ease-in;top:10%}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/Gauge.vue"],"names":[],"mappings":"AACA,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,wCACE,iBAAmB,CACpB,AACD,+CACI,qBAAuB,CAC1B,AACD,yBACE,kBAAmB,AACnB,WAAY,AACZ,iCAAkC,AAC1B,yBAA0B,AAClC,uCAAwC,AAChC,+BAAgC,AACxC,iDAAmD,AACnD,yCAA2C,AAC3C,iCAAmC,AACnC,+DAAmE,AACnE,OAAS,CACV","file":"Gauge.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.gauge-container[data-v-3ef3344e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.gauge-image-container[data-v-3ef3344e] {\n  position: relative;\n}\n.gauge-image-container .gauge[data-v-3ef3344e] {\n    vertical-align: bottom;\n}\n.needle[data-v-3ef3344e] {\n  position: absolute;\n  left: 47.8%;\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n  -webkit-transform-origin: bottom center;\n          transform-origin: bottom center;\n  -webkit-transition: -webkit-transform 0.3s ease-in;\n  transition: -webkit-transform 0.3s ease-in;\n  transition: transform 0.3s ease-in;\n  transition: transform 0.3s ease-in, -webkit-transform 0.3s ease-in;\n  top: 10%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".task-item-container[data-v-5940f673]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.task-item-container input[type=text][data-v-5940f673]{background-color:#fff;-webkit-box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.16);box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.16);height:40px;outline:none;padding:0 30px 0 14px;width:100%}.task-item-container input[disabled][data-v-5940f673]{background-color:#e6e6e6;-webkit-box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.16);box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.16)}.task-item-container .task-input[data-v-5940f673]{position:relative;margin-left:6px;width:100%}.task-item-container .task-input .delete-item[data-v-5940f673]{background-color:#ee3737;border-radius:50%;color:#fff;cursor:pointer;height:15px;position:absolute;right:9px;top:15px;width:15px}.task-item-container .task-input .delete-icon[data-v-5940f673]{font-size:15px;font-weight:700;vertical-align:baseline}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/TaskItem.vue"],"names":[],"mappings":"AACA,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,uDACI,sBAAwB,AACxB,qDAA0D,AAClD,6CAAkD,AAC1D,YAAa,AACb,aAAc,AACd,sBAAuB,AACvB,UAAY,CACf,AACD,sDACI,yBAA0B,AAC1B,qDAA0D,AAClD,4CAAkD,CAC7D,AACD,kDACI,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACf,AACD,+DACM,yBAA0B,AAC1B,kBAAmB,AACnB,WAAa,AACb,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,UAAY,CACjB,AACD,+DACM,eAAgB,AAChB,gBAAkB,AAClB,uBAAyB,CAC9B","file":"TaskItem.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.task-item-container[data-v-5940f673] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.task-item-container input[type=\"text\"][data-v-5940f673] {\n    background-color: white;\n    -webkit-box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);\n            box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);\n    height: 40px;\n    outline: none;\n    padding: 0 30px 0 14px;\n    width: 100%;\n}\n.task-item-container input[disabled][data-v-5940f673] {\n    background-color: #e6e6e6;\n    -webkit-box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);\n            box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);\n}\n.task-item-container .task-input[data-v-5940f673] {\n    position: relative;\n    margin-left: 6px;\n    width: 100%;\n}\n.task-item-container .task-input .delete-item[data-v-5940f673] {\n      background-color: #ee3737;\n      border-radius: 50%;\n      color: white;\n      cursor: pointer;\n      height: 15px;\n      position: absolute;\n      right: 9px;\n      top: 15px;\n      width: 15px;\n}\n.task-item-container .task-input .delete-icon[data-v-5940f673] {\n      font-size: 15px;\n      font-weight: bold;\n      vertical-align: baseline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".task-list-container[data-v-6f0e76be]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:649px}.task-list-container>[data-v-6f0e76be]{-webkit-box-flex:1;-ms-flex:1 1 calc(50% - 22px);flex:1 1 calc(50% - 22px);margin:0 0 15px 22px;max-width:289.5px}.task-list-container>[data-v-6f0e76be]:not(:nth-child(2n)){margin-left:0}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/TasksList.vue"],"names":[],"mappings":"AACA,sCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,eAAiB,CAClB,AACD,uCACE,mBAAoB,AAChB,8BAA+B,AAC3B,0BAA2B,AACnC,qBAAsB,AACtB,iBAAmB,CACpB,AACD,2DACE,aAAe,CAChB","file":"TasksList.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.task-list-container[data-v-6f0e76be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-width: 649px;\n}\n.task-list-container > *[data-v-6f0e76be] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 calc(50% - 22px);\n          flex: 1 1 calc(50% - 22px);\n  margin: 0 0 15px 22px;\n  max-width: 289.5px;\n}\n.task-list-container > *[data-v-6f0e76be]:not(:nth-child(2n)) {\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("49035261", content, true);

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1161);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("295f4cca", content, true);

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("8857f344", content, true);

/***/ }),

/***/ 1169:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("388a616d", content, true);

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1108),
  /* template */
  __webpack_require__(1177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20aa2ce3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1173:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1109),
  /* template */
  __webpack_require__(1178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ef3344e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1169)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1113),
  /* template */
  __webpack_require__(1182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f0e76be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/clock.png",
      "alt": "clock",
      "width": "47",
      "height": "47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-container"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Tiempo:")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("formatTime")(_vm.minute)) + ":" + _vm._s(_vm._f("formatTime")(_vm.second)) + "\n\t\t")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge-container"
  }, [_c('div', {
    staticClass: "gauge-image-container"
  }, [_c('img', {
    staticClass: "gauge",
    attrs: {
      "src": "/static/img/gauge.png",
      "alt": "gauge",
      "width": "78.9"
    }
  }), _vm._v(" "), _c('img', {
    ref: "needle",
    staticClass: "needle",
    style: (_vm.needleDeg),
    attrs: {
      "src": "/static/img/stick.png",
      "alt": "needle",
      "height": "34.6"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-2 gauge-text"
  }, [_vm._v(_vm._s(_vm.percent) + " %")])])
},staticRenderFns: []}

/***/ }),

/***/ 1180:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-item-container"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.isSelected,
      "checked": _vm.isSelected
    },
    on: {
      "change": _vm.onSelectTask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "task-item-text",
      "disabled": !_vm.isSelected,
      "aria-label": "Texto"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onTextChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "delete-item"
  }, [_c('v-icon', {
    staticClass: "delete-icon",
    on: {
      "click": _vm.onCloseTask
    }
  }, [_vm._v("close")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-list-container"
  }, _vm._l((_vm.tasks), function(task, index) {
    return _c('task-item', {
      key: task.id,
      attrs: {
        "is-selected": task.isSelected
      },
      on: {
        "task-selected": function($event) {
          _vm.onTaskSelected(index)
        },
        "task-delete": function($event) {
          _vm.onTaskDelete(index)
        }
      },
      model: {
        value: (task.text),
        callback: function($$v) {
          task.text = $$v
        },
        expression: "task.text"
      }
    })
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Clock__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_Clock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_TaskItem__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_TaskItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_TaskItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_TasksList__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_TasksList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__shared_TasksList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_Gauge__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_Gauge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_Gauge__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function created() {
	var _this = this;

	setInterval(function () {
		_this.percent = Math.round(Math.random() * 100);
	}, 2500);
}

function data() {
	return {
		percent: 50,
		showTask: true,
		task: {
			isSelected: true,
			text: 'El piso limpio'
		},
		tasks: [{
			id: 1,
			isSelected: true,
			text: 'Bano Limpio'
		}, {
			id: 2,
			isSelected: true,
			text: 'Sábanas limpias'
		}, {
			id: 3,
			isSelected: true,
			text: 'Habitación ordenada'
		}, {
			id: 4,
			isSelected: false,
			text: 'Refrigeradora limpio por dentro y fuera'
		}],
		time: '00:45'
	};
}

function onTaskDelete() {
	var _this2 = this;

	setTimeout(function () {
		_this2.showTask = false;
	}, 300);
}

function onTaskSelected() {
	this.task.isSelected = !this.task.isSelected;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Clock: __WEBPACK_IMPORTED_MODULE_0__shared_Clock___default.a,
		Gauge: __WEBPACK_IMPORTED_MODULE_3__shared_Gauge___default.a,
		TaskItem: __WEBPACK_IMPORTED_MODULE_1__shared_TaskItem___default.a,
		TasksList: __WEBPACK_IMPORTED_MODULE_2__shared_TasksList___default.a
	},
	created: created,
	data: data,
	name: 'docs',
	methods: {
		onTaskDelete: onTaskDelete,
		onTaskSelected: onTaskSelected
	}
});

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".docs-container[data-v-367d58fa]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/Docs.vue"],"names":[],"mappings":"AACA,iCACE,UAAY,CACb","file":"Docs.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.docs-container[data-v-367d58fa] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1478:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1393);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("3c9ad8e4", content, true);

/***/ }),

/***/ 1620:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "docs-container"
  }, [_c('section', [_c('article', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "275px"
    }
  }, [(_vm.showTask) ? _c('task-item', {
    attrs: {
      "is-selected": _vm.task.isSelected
    },
    on: {
      "task-selected": _vm.onTaskSelected,
      "task-delete": _vm.onTaskDelete
    },
    model: {
      value: (_vm.task.text),
      callback: function($$v) {
        _vm.task.text = $$v
      },
      expression: "task.text"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('article', [_vm._m(1), _vm._v(" "), _c('div', [_c('tasks-list', {
    attrs: {
      "tasks": _vm.tasks
    }
  })], 1)]), _vm._v(" "), _c('article', [_vm._m(2), _vm._v(" "), _c('div', [_c('clock', {
    attrs: {
      "time": _vm.time
    }
  })], 1)]), _vm._v(" "), _c('article', [_c('header', [_c('code', [_c('code', [_vm._v("<gauge v-bind:percent=\"" + _vm._s(_vm.percent) + "\" />")])])]), _vm._v(" "), _c('div', [_c('gauge', {
    attrs: {
      "percent": _vm.percent
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<task-item v-model=\"'El piso Limpio'\" v-bind:is-selected=\"true\"\n\t\t\t\t\t/>\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<tasks-list v-bind:tasks=\"tasks\" />")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<clock v-bind:time=\"'00:45'\" />")])])
}]}

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1478)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1327),
  /* template */
  __webpack_require__(1620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-367d58fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/34.57e4c332c68c2a18bd68.js